
import wixWindow from 'wix-window'

export const PROFESSIONS = {
	Developer: {
		label: 'Developer'
	},
	Designer: {
		label: 'Designer'
	},
	WixPartner: {
		label: 'Wix Partner'
	},
	ProfessionalAdAgency: {
		label: 'Professional Ad Agency'
	}
}

export const TYPES = {
	Feature: {
		label: 'Feature',
		color: '#FFE9AC'
	},
	API: {
		label: 'API',
		color: '#D6F1E4'
	},
	CodePackage: {
		label: 'Code Package',
		color: '#F8CBF6'
	},
}

export const SOURCES = {
	Community: {
		label: 'Community Request',
		color: '#DBD7F9'
	},
	Velo: {
		label: 'Velo',
		color: '#D6F1E4'
	},
}

export const STATUSES = {
	InReview: {
		label: 'In Review',
		color: null
	},
	Rejected: {
		label: 'Rejected',
		color: null
	},
	Pending: {
		label: 'Pending',
		color: '#DBD7F9'
	},
	Planning: {
		label: 'Planning',
		color: '#DBD7F9'
	},
	InDevelopment: {
		label: 'In Development',
		color: '#D3E5FE'
	},
	RollingOut: {
		label: 'Rolling Out',
		color: '#F9E2E3'
	},
	Released: {
		label: 'Released',
		color: '#F2EDE6'
	},
	Reassigned: {
		label: 'Reassigned',
		color: '#fcffa6'
	}
}

export const BI_INPUTS = {
	category: 'updates_and_release',
	referral_url: wixWindow.referrer
}